import React, { useState } from "react";
import { Modal, Form, Input, Select, Upload, Button, message } from "antd";
import { UploadOutlined } from "@ant-design/icons";

const { Option } = Select;

const CreateBannerModal = ({ visible, onClose, onCreate }) => {
  const [form] = Form.useForm();
  const [imageBase64, setImageBase64] = useState(null);

  const handleImageChange = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      setImageBase64(e.target.result); // base64 데이터로 설정
    };
    reader.readAsDataURL(file);
  };

  const handleCreate = async () => {
    try {
      const values = await form.validateFields();
      const currentTime = new Date().toISOString(); // 현재 시간

      const newBanner = {
        ...values,
        banner_url: imageBase64, // base64 이미지
        created_at: currentTime,
        updated_at: currentTime,
        admin_id: "admin", // 작성자 고정
      };

      await onCreate(newBanner); // 부모 컴포넌트로 데이터 전달
      form.resetFields();
      setImageBase64(null);
    } catch (error) {
      message.error("배너 생성에 실패했습니다.");
    }
  };

  return (
    <Modal
      title="새 배너 생성"
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={800}
    >
      <Form form={form} layout="vertical">
        <Form.Item
          name="banner_link"
          label="배너 링크"
          rules={[{ required: true, message: "배너 링크를 입력해주세요!" }]}
        >
          <Input />
        </Form.Item>
        {/* <Form.Item name="banner_position" label="배너 노출 순서">
          <Input type="number" />
        </Form.Item> */}
        <Form.Item
          name="banner_location"
          label="배너 위치"
          rules={[{ required: true, message: "배너 위치를 선택해주세요!" }]}
        >
          <Select>
            <Option value="home">홈</Option>
          </Select>
        </Form.Item>
        <Form.Item label="이미지 업로드">
          <Upload
            beforeUpload={(file) => {
              handleImageChange(file);
              return false; // 업로드 방지
            }}
            showUploadList={false}
          >
            <Button icon={<UploadOutlined />}>이미지 선택</Button>
          </Upload>
          {imageBase64 && (
            <img
              src={imageBase64}
              alt="업로드된 이미지"
              style={{ display: "block", marginTop: 10, width: 300 }}
            />
          )}
        </Form.Item>
      </Form>
      <div style={{ textAlign: "right", marginTop: "20px" }}>
        <Button
          type="primary"
          onClick={handleCreate}
          style={{ marginRight: 8 }}
        >
          생성
        </Button>
        <Button onClick={onClose}>취소</Button>
      </div>
    </Modal>
  );
};

export default CreateBannerModal;
